/**
 * Created by rlopez on 05/10/16.
 */
// AccountSettingsView.js
import { Model }            from 'backbone';
import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import NotificationService from 'NotificationService.js';
import AdvancedUserSignupModalView from 'common-views/AdvancedUserSignupModalView.js';
import CustomFontsModalView from 'common-views/CustomFontsModalView.js';
import SelectItemModalView from 'common-views/SelectItemModalView.js';
import RestService from 'RestService.js';
import contentTemplate  from 'dashboard/settings/account-settings-view.ejs';
import textConstants from 'TextConstants';
import eventBus from 'EventBus.js';
import constants from 'Constants.js';
import undoService from 'UndoService';
import util from 'util/Util';
import listService  from 'ListService.js';
import Spinner from 'spin/spin';
import Immutable from 'immutable';
import fontService from 'FontService.js'

const SILENT = constants.MODEL_SILENT;

class AccountSettingsView extends BasePropertyView {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;
        
        this.Spinner = new Spinner();

        this.events = {
            'click button[name=searchUser]': 'searchUser',
            'click button[name=editAdvancedOptions]': 'editAdvancedOptions',
            'change input[type=text],textarea[name=IPList]': 'manageTextInputs',
            'keyup input[type=text]': 'manageTextInputs',
            'blur textarea, input[type=text]'   : 'lostFocus',
            'focus textarea, input[type=text]'   : 'getFocus',
            'change input[type=checkbox]': 'manageCheckboxes',
            'change select[name=PasswordCharacters]': 'manageSelects',
            'click input[name=applyChanges]': 'applyChanges',
            'click input[name=cancelChanges]': 'cancelChanges',
            'change input[name=blockUser]': 'manageBlockUser',
            'change input[name=forcePassword]': 'manageForcePassword', 
            'click #goToSettings': 'goToSettings', 
            'click #goToAccountSettings': 'goToAccountSettings',
            'click button[name=editCustomFonts]': 'editCustomFonts',
            'change select[name=DesignRecoveryMinutes]': 'manageDesignMinutes',
            'change select[name=selectDefaultFont]': 'defaultFontSelectedChanged'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    editCustomFonts(){
        const currentSettings = this.model.get('currentAccountSettings');
        let customFonts = currentSettings ? this.model.get("currentAccountSettings").CustomFonts : '';
        customFonts = !customFonts || customFonts === '' ? [] : JSON.parse(customFonts);        

        const customFontsModal = new CustomFontsModalView({
            model: new Model({
                customFonts: customFonts,
                EditingFontName: '',
                EditingFontId: -1
            })
        });

        customFontsModal.render().then((customFontsModalResult)=> {
            if (customFontsModalResult) {
                if(customFontsModalResult.CustomFonts !== this.model.get("currentAccountSettings").CustomFonts){
                    let updatedSettings = Object.assign({}, currentSettings, customFontsModalResult);
                    this.model.set('currentAccountSettings', updatedSettings, {silent: true});
                    this.model.set('hasChanges', true, {silent: true});
                    this.render();
                }               
            }
        });
    }

    editAdvancedOptions() {
        let currentSettings = this.model.get('currentAccountSettings');
        const advancedModal = new AdvancedUserSignupModalView({
            model: new Model({
                UserSignUpActionId: currentSettings.UserSignUpActionId,
                UserSignUpConnectionId: currentSettings.UserSignUpConnectionId,
                UserSignUpCustomIdParameterId: currentSettings.UserSignUpCustomIdParameterId,
                UserSignUpEmailParameterId: currentSettings.UserSignUpEmailParameterId,
                UserSignUpFirstNameParameterId: currentSettings.UserSignUpFirstNameParameterId,
                UserSignUpLastNameParameterId: currentSettings.UserSignUpLastNameParameterId,
                UserSignUpLookupCaption: currentSettings.UserSignUpLookupCaption,
                UserSignUpLookupParameterId: currentSettings.UserSignUpLookupParameterId,
                UserSignUpUseLookup: currentSettings.UserSignUpUseLookup,
                UserSignUpAllowManualEditing: currentSettings.UserSignUpAllowManualEditing,
                IncludeCustomIdInUserSignUp: currentSettings.IncludeCustomIdInUserSignUp
            })
        });
        advancedModal.render().then((advancedModalSettings)=> {
            if (advancedModalSettings) {
                // console.log('Advanced Modal Settings', advancedModalSettings);
                let updatedSettings = Object.assign({}, currentSettings, advancedModalSettings);
                // console.log('Updated Settings', updatedSettings);
                this.model.set('currentAccountSettings', updatedSettings, {silent: true});
                this.model.set('hasChanges', true, {silent: true});
                this.render();
            }
        });
    }

    //
    manageSelects(ev) {
        // console.log("Entered to Selects");
        ev.preventDefault();
        this.setPasswordStrength(`input[name="PasswordStrength"]`, ev.currentTarget.value);
    }


    manageTextInputs(ev) {
        // console.log("Entered to Manage Text inputs");
        ev.preventDefault();
        let currentModel = this.model.get('currentAccountSettings');
        const propName = ev.currentTarget.name;
        const propValue = ev.currentTarget.value;

        switch (propName) {
            case 'PasswordStrength':
                if(isNaN(propValue)){
                    NotificationService.error("Please enter a valid number as a password strength");
                    this.render();
                }
                else {
                    this.setPasswordStrength('select[name="PasswordCharacters"]', propValue);
                }
                break;
            case 'IPList':
                currentModel[propName] = this.validateIPList(propValue);
                this.model.set('currentAccountSettings', currentModel, {silent: true});
                this.render();
                break;
            default:
                currentModel[propName] = propValue;
                this.model.set('currentAccountSettings', currentModel, {silent: true});
                this.model.set('hasChanges', true);
        }
    }

    setPasswordStrength(locator, value) {
        let currentModel = this.model.get('currentAccountSettings');
        currentModel.PasswordStrength = parseInt(value) + parseInt($(locator).val());
        this.model.set('currentAccountSettings', currentModel, {silent: true});
        this.model.set('hasChanges', true);
    }

    validateIPList(list) {
        let IPList = {
            IP: []
        };

        if (!list.includes(',')) {
            if (this.validateIP(list)) {
                IPList.IP = list;
                this.model.set('hasChanges', true, {silent: true});
                return IPList;
            }
            NotificationService.error('Your IP List is not valid');
            return this.model.get('currentAccountSettings').IPList;
        }
        let ipArray = list.split(',');

        for (let ip of ipArray) {
            if (!this.validateIP(ip)) {
                NotificationService.error('Your Ip List is not valid');
                return this.model.get('currentAccountSettings').IPList;
            }
            IPList.IP.push(ip);
        }
        this.model.set('hasChanges', true, {silent: true});
        return IPList;
    }

    validateIP(ip) {
        var valid=true;
        var x = ip.split(".");

        if(x.length > 4){
            return false;
        }

        var countAsterisk=0;
        for(var i=0; i<x.length;i++){

            if(x[i]==='*'){
                countAsterisk++;
            }else if( ( isNaN(parseInt(x[i], 10)) ) ||  ( parseInt(x[i],10) < 0 ) || ( parseInt(x[i],10) > 255 )){
                valid=false;
            }

        }

        if(countAsterisk === 0 && x.length < 4){
            return false;
        }
        return valid;
    }

    manageCheckboxes(ev) {
        ev.preventDefault();
        const currentModel = this.model.get('currentAccountSettings');
        const propName = ev.currentTarget.name;
        currentModel[propName] = ev.currentTarget.checked === true ? "True" : "False";
        this.model.set('currentAccountSettings', currentModel, SILENT);
        this.model.set('hasChanges', true, SILENT);
        this.render();
    }

    manageBlockUser(ev){
        const currentModel = this.model.get('currentAccountSettings');
        if (!ev.currentTarget.checked) {
            currentModel.FailedLoginsPermitted = 0;
            this.model.set('currentAccountSettings', currentModel, SILENT);
            this.model.set('hasChanges', true, SILENT);
            this.render();
        }
    }

    manageForcePassword(ev){
        const currentModel = this.model.get('currentAccountSettings');
        currentModel.ForcePasswordChangeDays = 0;
        if (!ev.currentTarget.checked) {
            currentModel.ForcePasswordChangeDays = 0;
            this.model.set('currentAccountSettings', currentModel, SILENT);
            this.model.set('hasChanges', true, SILENT);
            this.render();
        }
    }


    searchUser() {        
        this.Spinner.spin($(constants.CONTENT_ID).get(0));
        setTimeout(() => {
            RestService.browseAllUsers().then((userData)=> {
                // console.log('User Data', userData);
                let users = [];
                if (userData.AllUsers.User) {
                    users = userData.AllUsers.User instanceof Array
                        ? userData.AllUsers.User
                        : [userData.AllUsers.User];
                }

                let items = [];
                users.forEach(user => {                            
                    if (user['@type'] === 'user'){
                        items.push({ 
                            id: user['@id'],
                            label: user['@caption'],
                            listType: 'user',
                            items: user
                        });
                    }
                });

                const alertView = new SelectItemModalView({model: new Model({items: items}), spinner: this.Spinner});

                alertView.render().then(selectedItemInModal => {
                    // console.log('Selected Item', selectedItemInModal);
                    if (selectedItemInModal) {

                        let currentModel = this.model.get('currentAccountSettings');
                        currentModel.AdminUserName = selectedItemInModal.label;
                        currentModel.AdminUserId = selectedItemInModal.id;
                        this.model.set('currentAccountSettings', currentModel, {silent: true});
                        this.model.set('hasChanges',true, {silent:true});
                        this.render();
                    }
                });
            });
        }, 10);
    }

    formatIpListForResponse(ipList) {
        let permissionsOpeningTag = '<IPList>';
        let permissionsClosingTag = '</IPList>';
        let permissionList={};
        if(ipList.IP instanceof Array) {
            permissionList = ipList.IP.reduce((accum, elem)=> {
                return accum + `<IP>${elem}</IP>`
            }, '');
        }
        else{
            permissionList=`<IP>${ipList.IP}</IP>`;
        }
        permissionList = permissionsOpeningTag + permissionList + permissionsClosingTag;
        // console.log('CurrentIpListBeforeReplacing', permissionList);
        permissionList = permissionList.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        // console.log('CurrentIpList', permissionList);
        return permissionList;
    }

    applyChanges() {
        let currentModel = this.model.get('currentAccountSettings');

        const newAccountParams = Object.assign({},this.getAccountDTO(currentModel))
        const oldAccountParams = Object.assign({},this.getAccountDTO(this.model.get('accountSettings')));

        undoService.add({
            undo: () => {
                this.persistChanges(oldAccountParams)
            },
            redo: () => {
                this.persistChanges(newAccountParams)
            }
        }, textConstants.UNDO_UPDATE_ACCOUNT);
        this.persistChanges(newAccountParams);
        util.setUndoRedoAccess();

    }

    persistChanges(accountParams){
        RestService.updateAccount(accountParams).then((updateResponse)=> {
            listService.accountAPIEnabled = accountParams.apiEnabled.toString();
            listService.accountSettings.DefaultFontSelected = accountParams.DefaultFontSelected;
            NotificationService.success('Account Details were succesfully updated.');
            eventBus.trigger(constants.EV_UPDATED_ACCOUNT_SETTINGS);
        }).catch((err=> {
            NotificationService.error('Error while updating account settings ' + err);
        }));
    }
    
    defaultFontSelectedChanged(evt){

        if(!evt.target.options || !evt.target.selectedIndex)
        {
            NotificationService.error('Error while updating account settings.');
            return;
        }

        const currentSettings = this.model.get('currentAccountSettings');
        let defaultValue="Poppins";
        defaultValue = evt.target.options[evt.target.selectedIndex].value;

        let updatedSettings = Object.assign({}, currentSettings);
        updatedSettings.DefaultFontSelected = defaultValue;
        this.model.set('currentAccountSettings', updatedSettings, {silent: true});
        this.model.set('hasChanges', true);
    }

    getAccountDTO(model){
        const emptyIPAddressesValue = "&lt;IPList&gt;&lt;IP/&gt;&lt;/IPList&gt;";
        return {
            name: model.Name,
            fullName: model.AdminUserName,
            languageISO: model.LanguageISO,
            apiEnabled: model.APIEnabled === 'True',
            portalEnabled: model.PortalEnabled === 'True',
            directoryServiceEnabled: model.DirectoryServiceEnabled === 'True',
            ssoEnabled: model.SSOEnabled === 'True',
            apiIpAddresses: model.IPList ? this.formatIpListForResponse(model.IPList) : emptyIPAddressesValue,
            directoryServiceGatewayURL: model.DirectoryServiceGatewayURL,
            allowUserSignup: model.AllowUserSignup === 'True',
            useAlternativeUploadMechanism: model.UseAlternativeUploadMechanism === 'True',
            directoryServiceLoginOnly: model.DirectoryServiceLoginOnly === 'True',
            DirectoryServiceSSONotifLinks: (model.DirectoryServiceSSONotifLinks === 'True' || !model.DirectoryServiceSSONotifLinks),
            userSignUpUseLookup: model.UserSignUpUseLookup === 'True',
            userSignUpConnectionId: model.UserSignUpConnectionId,
            userSignUpActionId: model.UserSignUpActionId,
            userSignUpLookupParameterId: model.UserSignUpLookupParameterId,
            userSignUpLookupCaption: model.UserSignUpLookupCaption,
            userSignUpFirstNameParameterId: model.UserSignUpFirstNameParameterId,
            userSignUpLastNameParameterId: model.UserSignUpLastNameParameterId,
            userSignUpEmailParameterId: model.UserSignUpEmailParameterId,
            userSignUpAllowManualEditing: model.UserSignUpAllowManualEditing,
            allowUserEmailEdit: model.AllowUserEmailEdit === 'True',
            useSystemFont: model.UseSystemFont === 'True',
            includeCustomIdInUserSignUp: model.IncludeCustomIdInUserSignUp === 'True',
            allowUserEditOfOwnDetails: model.AllowUserEditOfOwnDetails === 'True',
            failedLoginsPermitted: model.FailedLoginsPermitted,
            userSignUpCustomIdParameterId: model.UserSignUpCustomIdParameterId,
            forcePasswordChangeDays: model.ForcePasswordChangeDays,
            includeFormInstancesByPermission: model.IncludeFormInstancesByPermission === 'True',
            directoryServicePassword: model.DirectoryServicePassword,
            passwordStrength: model.PasswordStrength,
            adminUserId: model.AdminUserId,
            accountEmailsToAll: model.AccountEmailsToAll === 'True',
            allowSelfSignedCert: model.AllowSelfSignedCert === 'True',
            customFonts: model.CustomFonts || '',
            // PF-8521
            designRecoveryEnabled: model.DesignRecoveryEnabled === 'True',
            designRecoveryMinutes: model.DesignRecoveryMinutes,
            DefaultFontSelected: model.DefaultFontSelected? model.DefaultFontSelected:'Poppins'
        };
    }

    cancelChanges() {
        this.model.set('currentAccountSettings',Object.assign({},this.model.get('accountSettings')),{silent:true});
        this.model.set('hasChanges',false);
        this.render();
    }

    render() {
        const html = this.template(this.model.toJSON());
        $(this.$el[0]).html(html);
        
        fontService.webFonts = this.model.get("hasChanges")?
            this.model.get("currentAccountSettings").WebFonts:this.model.get("accountSettings").WebFonts;
        fontService.userCustomFonts = this.model.get("hasChanges")?
        this.model.get("currentAccountSettings").CustomFonts:this.model.get("accountSettings").CustomFonts;

        $('#detailHeading').html('Settings - Dashboard');
        $("#selectDefaultFont").html(fontService.loadFontsDropDown(false));
        
        this.checkIfFontExist();

        if(RestService.getProfile().UserId === this.model.get('currentAccountSettings').AdminUserId){
            $("button[name='searchUser']").prop('disabled',false);
        }
        else{
            $("button[name='searchUser']").prop('disabled',true);
        }

        // Init Processing of special fields.
        let passwordStrength = this.model.get('currentAccountSettings').PasswordStrength;
        if (parseInt(passwordStrength) >= 512) {
            $('option[value="512"]').prop('selected', true);
            $('input[name="PasswordStrength"]').val(parseInt(passwordStrength) - 512);
        }
        else if (parseInt(passwordStrength) < 512 && parseInt(passwordStrength) >= 256) {
            $('option[value="256"]').prop('selected', true);
            $('input[name="PasswordStrength"]').val(parseInt(passwordStrength) - 256);
        }
        else {
            $('option[value="0"]').prop('selected', true);
            $('input[name="PasswordStrength"]').val(parseInt(passwordStrength));
        }

        let IPObject = this.model.get('currentAccountSettings').IPList;
        if (IPObject) {
            let IPList = IPObject.IP;
            let stringIP = '';
            if (IPList) {
                if (IPList instanceof Array) {
                    for (let IP of IPList) {
                        stringIP = stringIP + ',' + IP;
                    }
                    stringIP = stringIP.substring(1);
                }
                else {
                    stringIP = IPList;
                }
                $("textarea[name='IPList']").val(stringIP);
            }
        }

        // PF-8521
        $(`input[name='DesignRecoveryEnabled']`).prop('checked', this.model.get('currentAccountSettings').DesignRecoveryEnabled === 'True');
        $(`select[name='DesignRecoveryMinutes']`).val(this.model.get('currentAccountSettings').DesignRecoveryMinutes);
        $(`select[name='DesignRecoveryMinutes']`).prop('disabled', this.model.get('currentAccountSettings').DesignRecoveryEnabled === 'False');
        
        $('input[name="Name"]').trigger('focus').val("").val(this.model.get('currentAccountSettings').Name);

        // console.log('Has Changes', this.model.get('hasChanges'));
        this.$el.css('cursor', 'default');
        this.delegateEvents();
        return this;
    }

    checkIfFontExist()
    {
        let selectedFontFound = this.model.get("hasChanges")?
        $('#selectDefaultFont option[value="'+this.model.get("currentAccountSettings").DefaultFontSelected+'"]'):
            $('#selectDefaultFont option[value="'+this.model.get("accountSettings").DefaultFontSelected+'"]');

        if(selectedFontFound.length === 0)
        {
            $("#selectDefaultFont").val("Poppins");
        }
        else
        {
            selectedFontFound[0].selected = true;
        }
    }

    refresh(){
        this.cancelChanges();
        eventBus.trigger(constants.EV_REFRESH_ACCOUNT_DETAILS);
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();

       $('div.document-heading > a[data-target="#well_1"]').click();       
    }

    // PF-8521
    manageDesignMinutes(ev) {
        ev.preventDefault();
        this.setDesignRecoveryMinutes(ev.currentTarget.value);
    }

    setDesignRecoveryMinutes(value) {
        let currentModel = this.model.get('currentAccountSettings');
        currentModel.DesignRecoveryMinutes = value;
        this.model.set('currentAccountSettings', currentModel, {silent: true});
        this.model.set('hasChanges', true);
    }
}

export default AccountSettingsView;

